export default __webpack_public_path__ + "static/media/full_logo.e24cf5c6.png";